<template>
  <v-select
    ref="controlFocoSelectTarjeta"
    label="Tarjeta*"
    v-model="iModel"
    :items="items"
    item-value="Id_Tarjeta"
    item-text="Nombre"
    :rules="rules"
    :readonly="readonly"
    :loading="loading"
  >
    <template v-slot:no-data
      >No hay datos para mostrar</template
    >
    <template v-slot:progress>
      <v-progress-circular color="blue" indeterminate></v-progress-circular>
    </template>
  </v-select>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
import { eventBus } from "@/main";
export default {
  name: "SelectTarjeta",
  props: {
    model: Number,
    rules: {},
    readonly: Boolean
  },
  data() {
    return {
      items: [],
      loading: false
    };
  },
  computed: {
    iModel: {
      get() {
        return this.model;
      },
      set(valor) {
        var ind = this.items.findIndex(x => x.Id_Tarjeta == valor);
        this.$emit("seleccionarItem", this.items[ind]);
      }
    }
  },
  created() {
    eventBus.$on("setearFocoSelectTarjeta", this.setearFoco);
    this.listarItems();
  },
  beforeDestroy() {
    eventBus.$off("setearFocoSelectTarjeta", this.setearFoco);
  },
  methods: {
    listarItems() {
      this.loading = true;
      HttpHelper.get("Tarjeta", {
        palabra: ""
      })
        .then(response => {
          this.items = response.data;
          this.loading = false;
        })
        .catch(error => {
          return Promise.reject(error);
        });
    },
    setearFoco() {
      this.$refs.controlFocoSelectTarjeta.focus();
    }
  }
};
</script>
